import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import React, { useMemo, useEffect } from 'react';
import MapToComponents from 'react-map-to-components';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var DEFAULT_GET_TYPE = function DEFAULT_GET_TYPE(data) {
  return (data.__typename || '').replace(/^Prismic/, '');
};

var DEFAULT_GET_KEY = function DEFAULT_GET_KEY(data) {
  var _data$id;

  return (_data$id = data.id) !== null && _data$id !== void 0 ? _data$id : data.key;
};

var DEFAULT_LIST_MIDDLEWARE = function DEFAULT_LIST_MIDDLEWARE(list) {
  return list;
};

var DEFAULT_MAP_DATA_TO_PROPS = function DEFAULT_MAP_DATA_TO_PROPS(_ref) {
  var type = _ref.type;
  return {
    type: type
  };
};

var _mapObjValues = function _mapObjValues(fn, obj) {
  var result = {};

  for (var key in obj) {
    result[key] = fn(obj[key], key);
  }

  return result;
};

var MissingSlice = function MissingSlice(_ref2) {
  var type = _ref2.type;
  useEffect(function () {
    console.warn("Missing mapping for slice: ".concat(type));
  }, [type]);
  if (process.env.NODE_ENV !== 'development') return null;
  return React.createElement("div", {
    style: {
      all: 'unset',
      backgroundColor: '#ff8a91',
      color: 'red',
      display: 'block',
      fontFamily: 'system-ui',
      fontSize: '16px',
      padding: '64px 16px',
      textAlign: 'center',
      opacity: 0.5
    }
  }, React.createElement("p", {
    style: {
      fontWeight: 'bold',
      fontSize: '1.5em',
      marginBottom: '0.5em'
    }
  }, "Missing mapping for slice type: ", type), React.createElement("p", {
    style: {
      fontSize: '0.9em'
    }
  }, "Add the missing type to your slices map"));
};

var MapSlicesToComponents = function MapSlicesToComponents(_ref3) {
  var _ref3$map = _ref3.map,
      componentsMap = _ref3$map === void 0 ? {} : _ref3$map,
      _ref3$mapOverrides = _ref3.mapOverrides,
      mapOverrides = _ref3$mapOverrides === void 0 ? {} : _ref3$mapOverrides,
      _ref3$list = _ref3.list,
      listRaw = _ref3$list === void 0 ? [] : _ref3$list,
      _ref3$listMiddleware = _ref3.listMiddleware,
      listMiddleware = _ref3$listMiddleware === void 0 ? DEFAULT_LIST_MIDDLEWARE : _ref3$listMiddleware,
      _ref3$getKey = _ref3.getKey,
      getKey = _ref3$getKey === void 0 ? DEFAULT_GET_KEY : _ref3$getKey,
      _ref3$getType = _ref3.getType,
      getType = _ref3$getType === void 0 ? DEFAULT_GET_TYPE : _ref3$getType,
      _ref3$defaultMapDataT = _ref3.defaultMapDataToProps,
      defaultMapDataToProps = _ref3$defaultMapDataT === void 0 ? DEFAULT_MAP_DATA_TO_PROPS : _ref3$defaultMapDataT,
      props = _objectWithoutProperties(_ref3, ["map", "mapOverrides", "list", "listMiddleware", "getKey", "getType", "defaultMapDataToProps"]); // Returns an object containing the merged mapping of the the original page
  // map and the mapOverrides that is defined in any page level component.  If
  // an override exists for a slice, the new merged map will return the
  // overriden component.


  var mergedMap = useMemo(function () {
    return _mapObjValues(function (value, key) {
      return mapOverrides.hasOwnProperty(key) ? mapOverrides[key](value) : value;
    }, componentsMap);
  }, [componentsMap, mapOverrides]);
  var mapDataToProps = useMemo(function () {
    return _mapObjValues(function (value) {
      return value && value.mapDataToProps;
    }, componentsMap);
  }, [componentsMap]);
  var mapDataToContext = useMemo(function () {
    return _mapObjValues(function (value) {
      return value && value.mapDataToContext;
    }, componentsMap);
  }, [componentsMap]);
  var list = useMemo(function () {
    return listMiddleware(listRaw);
  }, [listRaw, listMiddleware]);
  return React.createElement(MapToComponents, _extends({
    getKey: getKey,
    getType: getType,
    "default": MissingSlice,
    defaultMapDataToProps: defaultMapDataToProps,
    list: list,
    map: mergedMap,
    mapDataToProps: mapDataToProps,
    mapDataToContext: mapDataToContext
  }, props));
};

MapSlicesToComponents.displayName = 'MapSlicesToComponents';
var index = React.memo(MapSlicesToComponents);
export default index;